import {
  PRIORITIES,
  REPORTERS,
  STATUSES,
  ACTIVE_STATUSES,
  HISTORIC_STATUSES,
  STATUS_TRANSITIONS,
  PRIORITY_COLORS
} from "../models/incidents";

import {formatTimestamp} from "../../../../utils/date.helpers";



export function normalizeEnumValue(value) {
  if (value == null) return "";
  return String(value).trim().toUpperCase();
}

export function isValidPriority(value) {
  return Object.values(PRIORITIES).includes(value);
}

export function isValidStatus(value) {
  return Object.values(STATUSES).includes(value);
}

export function isValidReporter(value) {
  return Object.values(REPORTERS).includes(value);
}

export function isActiveStatus(status) {
  return ACTIVE_STATUSES.includes(status);
}

export function isHistoricStatus(status) {
  return HISTORIC_STATUSES.includes(status);
}

export function getAllowedNextStatuses(currentStatus) {
  return STATUS_TRANSITIONS[currentStatus] || [];
}

export function normalizeReportedUndefinedPair(draft) {
  const next = { ...draft };
  if (next.status === STATUSES.REPORTED) {
    next.priority = PRIORITIES.UNDEFINED;
  }

  return next;
}

export const canTransitionStatus = (from, to) => {
  if (from === to) return true;
  const allowed = getAllowedNextStatuses(from);
  return allowed.includes(to);
};


export function buildPriorityLegendItems() {
  const getColor = (p) => PRIORITY_COLORS[p] || "#9ca3af";

  return [
    { key: PRIORITIES.HIGH, label: "HIGH", color: getColor(PRIORITIES.HIGH) },
    { key: PRIORITIES.MEDIUM, label: "MEDIUM", color: getColor(PRIORITIES.MEDIUM) },
    { key: PRIORITIES.LOW, label: "LOW", color: getColor(PRIORITIES.LOW) },
    { key: PRIORITIES.UNDEFINED, label: "UNDEFINED", color: getColor(PRIORITIES.UNDEFINED) },
  ];
}

export function consumeIncident(incident) {
  return {
    id: incident.id,
    latitude: Number(incident.latitude),
    longitude: Number(incident.longitude),
    timestamp: formatTimestamp(incident.timestamp),
    reporter: incident.reporter ?? REPORTERS.CITIZEN,
    priority: incident.priority ?? PRIORITIES.UNDEFINED,
    status: incident.status ?? STATUSES.REPORTED,
    description: incident.description ?? "",
    segmentId: incident.segmentId ?? null,
    photoUrl: incident.photoUrl ?? null,
  };
}
